<template>
  <div class="horizontal-ads" v-if="itemsRendered">
    <table class="ha-table">
      <tbody>
        <tr>
          <th class="head-text">Featured Account Options</th>
          <th class="sponsored-head">
            <span class="sponsored-text">SPONSORED LISTINGS</span>
          </th>
        </tr>
         <tr>
          <td colspan="3" class="anchor-tag four-a-color">
            <how-da-gets-paid></how-da-gets-paid> <span style="padding-left: 4px; padding-right: 4px; color: #aaa;">  | </span> <ad-disclosure-tooltip></ad-disclosure-tooltip>
          </td>
        </tr>
        <tr>
          <horizontal-ad v-for="ad in ads" v-bind:key="ad.id" v-bind:ad="ad"></horizontal-ad>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import horizontalAd from "./horizontalAd.vue";
import apiClient from "../../services/apiClient";
import analytics from "../../services/analytics";
import howDaGetsPaid from '../../components/how-da-get-paid.vue';
import adDisclosureTooltip from '../../components/ad-disclosure-tooltip.vue';

export default defineComponent({
  name: "horizontalAds",
  components: {
    horizontalAd: horizontalAd,
    howDaGetsPaid,
    adDisclosureTooltip
  },
  props: {
    bank: Object
  },
  data: function() {
    return {
      ads: [] as AdPlacement[],
      itemsRendered: false
    };
  },
  mounted() {

    apiClient
      .getAdPlacementsInZone("da-bp-h")
      .then(adsData => {
        if (!(adsData && adsData.length)) {
          return;
        }
        this.ads = adsData;
        analytics.trackAdImpressions("da-bp-h", adsData);
      })
      .finally(() => {
        //make visible on next tick, after rendering
        this.$nextTick(() => {
          this.itemsRendered = true;
        });
      });
  }
});
</script>
<style lang="scss" scoped>
.horizontal-ads {
  color: #000;
  font-size: 11px;
  margin-bottom: 5px;
  padding: 5px 0px 9px;
  .ha-table {
    width: 100%;
    padding-top: 8px;
    .head-text {
      color: #01538b;
      font-size: 14px;
      font-weight: bold;
      padding-top: 8px;
      padding-bottom: 8px;
    }
    
    .sponsored-head {
      vertical-align: top;
      text-align: right;
    }
    .sponsored-text {
      color: #666;
      font-weight: normal;
    }
  }
}
</style>
